import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpRepo } from '@shared/services/httprepo';
import { ApiEndPointType } from '@shared/enums/common';
import { AuthService } from '@services/auth.service';
import { CommonMethods } from '@services/common.method';

@Injectable({
  providedIn: 'root'
})
export class MaterialItemService {

  constructor(    
    private auth: AuthService,
    private httpRepo: HttpRepo,
    private commonMethod: CommonMethods
  ) {
    httpRepo.setAbsoluteUrl(this.auth.getCompanyId(), ApiEndPointType.FS);
  }

    // GET Work Order
    GetMaterialItem(ID:any):Observable<any>{
      return this.httpRepo.Get("pricebook/materialitems/" + ID + "?references=*");      
    }
    // POST
    public SaveMaterialItem(data :any):Observable<any>{
      data.ID = CommonMethods.GetID();
      return this.httpRepo.Post("pricebook/materialitems",data );
    }

    public UploadImage(formData){
      return this.httpRepo.PostFile("/pricebook/materialitemsattachment",formData) // Send the state to the server
    }

    public UploadExternalImage(formData){
      return this.httpRepo.Post("pricebook/externalmaterialitemsattachment",formData) // Send the state to the server
    }

    public DeleteMaterialItem(data :any):Observable<any>{
      return null;
    }

    public GetCompanyResources():Observable<any>{
      return this.httpRepo.GetReferences("?references=CodeTypeData,ItemManufacturers,PriceBookAccountingCodes,PriceBuckets");
    }

    // PUT
    public EditMaterialItem(data: any): Observable<any> {
      return this.httpRepo.Put("pricebook/materialitems/" + data.ID, data);
    }
    public CreateMaterialItem(data: any): Observable<any> {
        data.ModifyDate="01-01-0001";    
        data.ID = CommonMethods.GetID();
        return this.httpRepo.Post("pricebook/materialitems", data);
    }

    public UploadDocument():string{
      return this.httpRepo.AbsoluteURL + "/pricebook/materialitemsattachment";
    }
    
    public UploadExternalDocument(val: string){
      return this.httpRepo.Post("pricebook/externalmaterialitemsattachment", val);
    }
}
